import CameraAddVehicle from './CameraAddVehicle';
import IWidget from './iwidget';


const widgets: {[key: string]: IWidget;} = {
  'camera_addvehicle': CameraAddVehicle
}

export default widgets;